import { UploadProps, message, Upload } from "antd";
import { renderAntDMessageConfig } from "../../../../utils/renderAntDMessageConfig";

export const imageProps: UploadProps = {
  name: "file",
  action: "https://httpbin.org/post",
  headers: {
    authorization: "authorization-text",
  },
  beforeUpload: (file) => {
    const isImage = file.type.startsWith("image");
    const isLt1MB = file.size < 1024 * 1024;

    if (!isImage) {
      message.error(renderAntDMessageConfig("Wrong file format!"));
      return Upload.LIST_IGNORE;
    }

    if (!isLt1MB) {
      message.error(
        renderAntDMessageConfig("이미지 크기는 1MB 미만이어야 합니다!")
      );
      return Upload.LIST_IGNORE;
    }
  },
};

export const fileProps: UploadProps = {
  name: "file",
  action: "https://httpbin.org/post",
  headers: {
    authorization: "authorization-text",
  },
  beforeUpload: (file) => {
    const isImage = file.type.startsWith("image");
    const isLt1MB = file.size < 1024 * 1024;

    if (isImage) {
      message.error(
        renderAntDMessageConfig("이미지는 이미지 업로드 영역에 첨부해주세요!")
      );
      return Upload.LIST_IGNORE;
    }

    if (!isLt1MB) {
      message.error(
        renderAntDMessageConfig("파일 크기는 1MB 미만이어야 합니다!")
      );
      return Upload.LIST_IGNORE;
    }
  },
};
